// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'secondary', 'secondary Fallback'","fontWeight":700,"fontStyle":"normal"},"className":"__className_21518d","variable":"__variable_21518d"};